export default __webpack_public_path__ + "static/media/bg7.c4933591.jpg";